import { z } from 'zod';

const FeatureFlagsSchema = z.object({
  enableReferrals: z.boolean(),
  enableLeaderboards: z.boolean(),
  enableActivityFeed: z.boolean(),
  enableEmailLink: z.boolean(),
});

export const BootupSchema = z.object({
  appleReviewVersion: z.string().optional(),
  minWebVersion: z.number(),
  minAndroidVersion: z.number(),
  minIOSVersion: z.number(),
  minInHouseWidgetVersion: z.number().optional(),
  minOperatorWidgetVersion: z.number().optional(),
  androidDownloadLink: z.string(),
  iosDownloadLink: z.string(),
  featureFlags: FeatureFlagsSchema,
});
export type BootupData = z.infer<typeof BootupSchema>;
